  <template>
  <v-layout row justify-center>
    <v-dialog persistent v-model="status" max-width="500">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 lg6>
                <DateTimePicker
                  ref = 'reqdate'
                  label="Release Date"/>
                  <v-text-field v-model="data.rate" type="number" min="0" max="100" label="Funds (%)" @input="updateRate"></v-text-field>
              </v-flex>
              <v-flex xs12 lg6>
                <v-text-field v-model="data.totalf" readonly label="Total Funds" @input="test"></v-text-field>
                <v-text-field v-model="data.funds" label="Funds" @input="updateFunds"></v-text-field>
                <!-- <vue-numeric currency="Rp." separator="." v-model="data.totalf" :precision="0"></vue-numeric> -->
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="data.note" label="Note" multi-line rows="3"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click="ChangeP">Cancel</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="Apply">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="3000"
      top
      v-model="snackbar"
    >
      {{ error }}
      <v-btn flat color="pink" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
import DateTimePicker from '@/components/lookup/DateTimePicker'
import numformat from '@/assets/js/accounting.min.js'
import VueNumeric from 'vue-numeric'
export default {
  components: {
    DateTimePicker,
    VueNumeric
  },
  props: {
    status: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    data: {
      date: '',
      totalf: 0,
      note: '',
      rate: 100,
      funds: 0
    },
    snackbar: false,
    error: ''
  }),
  methods: {
    test () {
      let tmp = numformat.unformat(this.data.totalf, ',')
      this.data.totalf = numformat.formatMoney(tmp, '', 0, '.', ',')
    },
    updateRate (val) {
      this.data.funds = numformat.formatMoney(((numformat.unformat(this.data.totalf, ',')) * val / 100), '', 0, '.', ',')
    },
    updateFunds (val) {
      let tmp = numformat.unformat(val, ',')
      this.data.rate = tmp * 100 / numformat.unformat(this.data.totalf, ',')
      this.data.funds = numformat.formatMoney(tmp, '', 0, '.', ',')
    },
    ChangeP () {
      this.clear()
      this.$emit('changeP')
    },
    Apply () {
      this.data.date = this.$refs.reqdate.getdatetime()
      if (this.validate()) {
        this.$emit('apply', this.data)
      } else {
        this.snackbar = true
      }
    },
    validate () {
      if (!this.data.date || this.data.date === '') {
        this.error = 'Date Is Required'
        return false
      }
      if (this.data.totalf == null || this.data.totalf === '') {
        this.error = 'Total is Required'
        return false
      }
      return true
    },
    clear () {
      this.$refs.reqdate.clear()
      this.data = {
        date: '',
        totalf: 0,
        note: '',
        rate: 100,
        funds: 0
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bt-unreleasefunds/BT-UnreleaseDialog.vue